import { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/faqs`);
        setFaqs(response.data);
      } catch (error) {
        console.error('Error fetching FAQs:', error);
        setFaqs([
          {
            question: 'Berapa biaya pengelolaan properti?',
            answer: 'Biaya disesuaikan dengan skema kerjasama yang dipilih.'
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <section id="faq" className="py-20 md:py-32 px-6 lg:px-12 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-isk-teal tracking-tight mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-isk-teal/70">
            Pertanyaan umum seputar kerjasama dengan ISK
          </p>
        </div>

        <div className="space-y-4" data-testid="faq-accordion">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="glass-card rounded-xl overflow-hidden border-0"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full text-left px-6 py-6 flex items-center justify-between hover:bg-white/50 transition-colors"
              >
                <span className="text-lg font-semibold text-isk-teal pr-4">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-isk-teal flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-isk-teal/70">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
